<template>
  <v-dialog :value="value" max-width="460" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-subtitle-1 font-weight-bold">{{ title }}</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="save">
          <template v-if="kind === 'brand'">
            <v-text-field dense outlined autofocus label="Nome da marca" v-model="form.name"
              :rules="[$rules.required]" hide-details="auto" placeholder="Ex.: Volkswagen" />
          </template>
          <template v-else>
            <v-autocomplete dense outlined label="Marca" :items="brands" item-text="name" item-value="id"
              v-model="form.brand_id" :rules="[$rules.required]" hide-details="auto" class="mb-4" />
            <v-text-field dense outlined :autofocus="!!form.brand_id" label="Modelo" v-model="form.model"
              :rules="[$rules.required]" hide-details="auto" placeholder="Ex.: Polo 1.0 TSI"
              hint="Inclua versão e motor quando a manutenção for diferente (TSI, MSI, 1.6...)" persistent-hint />
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Cancelar</v-btn>
        <v-btn color="primary" depressed :loading="saving" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

// Cadastro rápido de marca ou modelo (usado no veículo e em Marcas e modelos)
export default {
  name: 'VehicleCatalogDialog',

  props: {
    value: { type: Boolean, default: false },
    kind: { type: String, default: 'brand' },
    item: { type: Object, default: null },
    brands: { type: Array, default: () => [] },
    brandId: { type: [Number, String], default: null }
  },

  data: () => ({
    saving: false,
    form: {}
  }),

  computed: {
    title() {
      const editing = this.item && this.item.id
      if (this.kind === 'brand') return editing ? 'Editar marca' : 'Nova marca'
      return editing ? 'Editar modelo' : 'Novo modelo'
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(open) {
        if (!open) return
        const item = this.item || {}
        this.form = this.kind === 'brand'
          ? { name: item.name || '' }
          : { model: item.model || '', brand_id: item.brand_id || this.brandId || null }
        this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
      }
    }
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return

      const base = this.kind === 'brand' ? '/api/v2/vehicle-brands' : '/api/v2/vehicle-models'
      const id = this.item && this.item.id

      this.saving = true
      try {
        const response = id ? await axios.patch(`${base}/${id}`, this.form) : await axios.post(base, this.form)
        this.$dialog.notify.success(this.kind === 'brand' ? 'Marca salva' : 'Modelo salvo', { position: 'top-right', timeout: 2500 })
        this.$emit('saved', response.data.content)
        this.$emit('input', false)
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
